import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SortableHandle } from 'react-sortable-hoc';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import ReorderIcon from '@material-ui/icons/Reorder';
import ArrowUp from '@material-ui/icons/ArrowUpward';
import ArrowDown from '@material-ui/icons/ArrowDownward';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const SortableHandleElem = SortableHandle(({ className }) => <ReorderIcon className={className} />);

class AttributeCard extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    attribute: PropTypes.object.isRequired,
    layout: PropTypes.array.isRequired,
    removeSection: PropTypes.func.isRequired,
    onLayoutChange: PropTypes.func.isRequired,
    itemIndex: PropTypes.number.isRequired,
  };

  state = {
    collapse: true,
  };

  handleRemoveClick = () => {
    this.setState({ collapse: false });
  };

  handleOnExited = () => {
    this.props.removeSection(this.props.attribute.name);
  };

  handleDown = () => {
    const { itemIndex, onLayoutChange } = this.props;
    onLayoutChange({ oldIndex: itemIndex, newIndex: itemIndex + 1 });
  };

  handleUp = () => {
    const { itemIndex, onLayoutChange } = this.props;
    onLayoutChange({ oldIndex: itemIndex, newIndex: itemIndex - 1 });
  };

  render() {
    const { classes, layout, attribute, itemIndex } = this.props;
    return (
      <Collapse in={this.state.collapse} timeout={250} onExited={this.handleOnExited}>
        <div className={classes.root}>
          <div className={classes.iconContainer}>
            <SortableHandleElem className={classes.dragHandleIcon} />
            {itemIndex !== 0 && <ArrowUp onClick={this.handleUp} className={classes.arrowIcon} />}
            {itemIndex !== layout.length - 1 && (
              <ArrowDown onClick={this.handleDown} className={classes.arrowIcon} />
            )}
          </div>
          <Card className={classes.card} classes={{ root: classes.cardRoot }}>
            <CardHeader
              classes={{ root: classes.headerRoot, content: classes.headerContent }}
              title={<Typography variant="h5">{attribute.value.displayName}</Typography>}
              action={
                <IconButton aria-label="remove" onClick={this.handleRemoveClick}>
                  <RemoveCircleOutlineIcon className={classes.removeCircle} />
                </IconButton>
              }
            />
          </Card>
        </div>
      </Collapse>
    );
  }
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(2),
    '-webkit-touch-callout': 'none' /* iOS Safari */,
    '-webkit-user-select': 'none' /* Safari */,
    ' -khtml-user-select': 'none' /* Konqueror HTML */,
    '-moz-user-select': 'none' /* Firefox */,
    '-ms-user-select': 'none' /* Internet Explorer/Edge */,
    'user-select': 'none',
  },
  card: {
    width: '100%',
    marginRight: theme.spacing(3),
  },
  cardRoot: {
    padding: `${theme.spacing()}px !important`,
    marginBottom: 0,
  },
  headerRoot: {
    padding: `0 ${theme.spacing()}px 0 ${theme.spacing()}px !important`,
    height: theme.spacing(8),
    alignContent: 'flex-start',
  },
  headerContent: {
    alignSelf: 'flex-start',
  },
  removeCircle: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    color: theme.colors.gray1,
  },
  dragHandleIcon: {
    marginBottom: theme.spacing(),
    height: theme.spacing(2.5),
    width: theme.spacing(2.5),
    cursor: 'move',
    color: theme.colors.gray1,
  },
  iconContainer: {
    marginRight: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(),
  },
  arrowIcon: {
    cursor: 'pointer',
    color: theme.colors.gray1,
    height: theme.spacing(2.5),
    width: theme.spacing(2.5),
  },
});

export default withStyles(styles)(AttributeCard);
